const $8e234942e6a87d00$export$276d1de0bc02ff5b = 'http://www.w3.org/2000/svg';
class $8e234942e6a87d00$export$7b5bf7981d51054e {
    find(id) {
        if (this.id === id) return this;
        for (const child of this.children){
            const found = child.find(id);
            if (found) return found;
        }
        return undefined;
    }
}


class $9ff2d73067b60eff$export$5a436664b26b5bb8 {
}
class $9ff2d73067b60eff$export$7955351c9f2e4bbf {
    constructor(defaultValue, decimalPoints){
        this.defaultValue = defaultValue;
        this.decimalPoints = decimalPoints;
        this.value = defaultValue;
    }
    parse(value) {
        const parsed = parseFloat(value);
        this.value = Number.isNaN(parsed) ? Number.NaN : parsed;
    }
    get isValid() {
        return !Number.isNaN(this.value);
    }
    format() {
        return this.isValid ? this.value.toFixed(this.decimalPoints) : '';
    }
}
class $9ff2d73067b60eff$export$a770ed677459fd90 {
    constructor(defaultValue){
        this.defaultValue = defaultValue;
        this.value = defaultValue;
    }
    parse(value) {
        if (typeof value === 'boolean') {
            this.value = value;
            return;
        }
        this.value = value === 'true';
    }
    get isValid() {
        return true;
    }
    format() {
        return this.value.toString();
    }
}
const $9ff2d73067b60eff$export$7c24c21e0aad25cf = {
    rimErd: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(495, 1),
    rimNumHoles: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(32, 0),
    rimDrillingOffsetDs: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(0, 1),
    rimDrillingOffsetNds: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(0, 1),
    rimFlipOffsetOrder: new $9ff2d73067b60eff$export$a770ed677459fd90(false),
    dsFlangePcd: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(35, 1),
    ndsFlangePcd: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(35, 1),
    dsFlangeOffset: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(35, 1),
    ndsFlangeOffset: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(35, 1),
    dsFlangeNumHoles: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(16, 0),
    ndsFlangeNumHoles: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(16, 0),
    hubRotation: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(0.25, 2),
    dsNdsOffset: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(0.5, 2),
    spokeHoleDiameter: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(2.6, 1),
    spokeGroupingPrecision: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(1, 1)
};
const $9ff2d73067b60eff$export$72cb2a5beca2f59c = {
    realisticScale: new $9ff2d73067b60eff$export$a770ed677459fd90(false),
    ndsView: new $9ff2d73067b60eff$export$a770ed677459fd90(false),
    angleThreshold: new $9ff2d73067b60eff$export$7955351c9f2e4bbf(10, 0)
};
const $9ff2d73067b60eff$export$8b6913a10491b785 = (parameters)=>{
    for (const parameter of Object.values(parameters)){
        if (!parameter.isValid) return false;
    }
    return true;
};


const $a8b110203455cd55$export$50fdfeece43146fd = ()=>{
    if (!window.spokeCalc) window.spokeCalc = {
        selectedId: undefined,
        wheelParameters: (0, $9ff2d73067b60eff$export$7c24c21e0aad25cf),
        viewParameters: (0, $9ff2d73067b60eff$export$72cb2a5beca2f59c),
        wheel: undefined,
        refresh: ()=>{},
        select: (id)=>{
            const state = $a8b110203455cd55$export$50fdfeece43146fd();
            state.selectedId = id;
            state.refresh();
        }
    };
    return window.spokeCalc;
};


const $36c58dd8c5475691$export$d6d3992f3becc879 = 3;





class $2dbce3f90165c269$export$b5329b670b24e23b extends (0, $8e234942e6a87d00$export$7b5bf7981d51054e) {
    constructor(id, props){
        super(), this.id = id, this.props = props, this.children = [];
        this.location = props.location;
        this.selectable = props.selectable ?? true;
    }
    update(props) {
        this.props = {
            ...this.props,
            ...props
        };
        this.location = this.props.location;
    }
    get xyMm() {
        const a = Math.PI / 180 * (this.props.angle - 90);
        return [
            Math.cos(a) * this.props.distance,
            Math.sin(a) * this.props.distance
        ];
    }
    get centerOffset() {
        return this.props.centerOffset || 0;
    }
    xy(viewCtx) {
        const dist = viewCtx.schematicView ? this.schematicDist(viewCtx) : this.props.distance * viewCtx.scaler.pxPerMm;
        const a = Math.PI / 180 * (this.props.angle - 90);
        const correction = viewCtx.viewSide === 'nds' ? -1 : 1;
        return [
            Math.cos(a) * dist * correction,
            Math.sin(a) * dist
        ];
    }
    d(viewCtx) {
        return viewCtx.schematicView ? this.schematicDiameter(viewCtx) : this.props.diameter * viewCtx.scaler.pxPerMm;
    }
    get isOnRim() {
        return this.location.split('-')[0] === 'rim';
    }
    get isOnFlange() {
        return this.location.split('-')[0] === 'flange';
    }
    schematicDiameter(viewCtx) {
        const scaler = viewCtx.scaler;
        switch(this.props.location){
            case 'rim':
                return scaler.schematicRimHoleDiameter;
            case 'rim-ds':
                return viewCtx.viewSide === 'ds' ? scaler.schematicNearRimHoleDiameter : scaler.schematicFarRimHoleDiameter;
            case 'rim-nds':
                return viewCtx.viewSide === 'nds' ? scaler.schematicNearRimHoleDiameter : scaler.schematicFarRimHoleDiameter;
            case 'flange-ds':
                return viewCtx.viewSide === 'ds' ? scaler.schematicNearFlangeHoleDiameter : scaler.schematicFarFlangeHoleDiameter;
            case 'flange-nds':
                return viewCtx.viewSide === 'nds' ? scaler.schematicNearFlangeHoleDiameter : scaler.schematicFarFlangeHoleDiameter;
            case 'nipple':
                return scaler.schematicNippleHoleDiameter;
            case 'axle':
                return scaler.schematicAxleDiameter;
            default:
                return 0;
        }
    }
    schematicDist(viewCtx) {
        const scaler = viewCtx.scaler;
        let d = 0;
        switch(this.props.location){
            case 'rim':
            case 'rim-ds':
            case 'rim-nds':
            case 'nipple':
                d = (scaler.schematicRimInnerDiameter + scaler.schematicRimOuterDiameter) / 2;
                break;
            case 'flange-ds':
                d = viewCtx.viewSide === 'ds' ? scaler.schematicNearFlangeDiameter : scaler.schematicFarFlangeDiameter;
                break;
            case 'flange-nds':
                d = viewCtx.viewSide === 'nds' ? scaler.schematicNearFlangeDiameter : scaler.schematicFarFlangeDiameter;
                break;
            default:
                break;
        }
        return d / 2;
    }
    isOnFarSide(viewSide) {
        const locationSide = this.location.split('-')[1];
        return !!locationSide && locationSide !== viewSide;
    }
    get isOnDs() {
        const locationSide = this.location.split('-')[1];
        return !locationSide || locationSide === 'ds';
    }
    render(viewCtx) {
        const isSelected = (0, $a8b110203455cd55$export$50fdfeece43146fd)().selectedId === this.id;
        const circle = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
        circle.setAttribute('id', this.id);
        const title = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'title');
        title.textContent = `Hole ${this.id}`;
        circle.appendChild(title);
        circle.classList.add('hole');
        isSelected && circle.classList.add('selected');
        this.isOnFarSide(viewCtx.viewSide) && circle.classList.add('far-side');
        !this.selectable && circle.classList.add('select-resetting');
        const [x, y] = this.xy(viewCtx);
        circle.setAttribute('cx', x.toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        circle.setAttribute('cy', y.toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        circle.setAttribute('r', (this.d(viewCtx) / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        this.addEventHandlers(circle);
        return circle;
    }
    addEventHandlers(elem) {
        if (!this.selectable) return;
        elem.addEventListener('click', ()=>{
            const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
            if (state.selectedId === this.id) state.select(undefined);
            else if (state.selectedId === undefined) state.select(this.id);
            else if (!(state.wheel?.find(state.selectedId) instanceof $2dbce3f90165c269$export$b5329b670b24e23b)) state.select(this.id);
            else if (state.selectedId !== undefined && state.selectedId !== this.id) {
                const otherHole = state.wheel?.find(state.selectedId);
                if (otherHole) {
                    const added = state.wheel?.addSpoke(this, otherHole);
                    state.refresh();
                    if (!added) state.select(this.id);
                }
            }
        });
    }
}



class $2f44413d4ef6c8fa$export$8adfa152bd3633af extends (0, $8e234942e6a87d00$export$7b5bf7981d51054e) {
    constructor(id, props){
        super(), this.id = id, this.props = props;
        this.holes = this.generateHoles();
    }
    get children() {
        return this.holes;
    }
    update(props) {
        this.props = {
            ...this.props,
            ...props
        };
        const newHoles = this.generateHoles();
        const n = Math.max(newHoles.length, this.holes.length);
        for(let i = 0; i < n; i++){
            const oldHole = this.holes[i];
            const newHole = newHoles[i];
            if (oldHole && newHole) oldHole.update(newHole.props);
            else if (!oldHole && newHole) this.holes[i] = newHole;
            else if (oldHole && !newHole) {
                this.holes = this.holes.slice(0, i);
                break;
            }
        }
    }
    generateHoles() {
        const holes = [];
        const angleStep = 360 / this.props.numHoles;
        const initAngle = angleStep * this.props.rotation;
        for(let i = 0; i < this.props.numHoles; i++){
            const angle = initAngle + angleStep * i;
            let location = this.props.side === 'ds' ? 'flange-ds' : 'flange-nds';
            const idPrefix = this.props.side === 'ds' ? 'S' : 'N';
            holes.push(new (0, $2dbce3f90165c269$export$b5329b670b24e23b)(`${idPrefix}${i + 1}`, {
                angle: angle,
                distance: this.props.pcd / 2,
                diameter: this.props.spokeHoleDiameter,
                location: location,
                centerOffset: this.props.centerOffset
            }));
        }
        return holes;
    }
    render(viewCtx) {
        const s = viewCtx.scaler;
        const group = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'g');
        group.classList.add('flange');
        group.setAttribute('id', this.id);
        const sampleHole = this.children[0];
        const holeDiameter = sampleHole.schematicDiameter(viewCtx);
        const schematicPcd = viewCtx.viewSide === this.props.side ? s.schematicNearFlangeDiameter : s.schematicNearFlangeDiameter + holeDiameter * 3;
        const flangeDiameter = viewCtx.schematicView ? schematicPcd + holeDiameter * 2 : s.pxPerMm * (this.props.pcd + this.props.spokeHoleDiameter * 2);
        const circle = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
        circle.classList.add(this.props.side == viewCtx.viewSide ? 'near-flange' : 'far-flange');
        circle.classList.add('select-resetting');
        circle.setAttribute('cx', '0');
        circle.setAttribute('cy', '0');
        circle.setAttribute('r', (flangeDiameter / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        group.appendChild(circle);
        const axleDiameter = viewCtx.schematicView ? viewCtx.scaler.schematicAxleDiameter : 10 * s.pxPerMm;
        const axle = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
        axle.classList.add('axle-hole', 'select-resetting');
        axle.setAttribute('cx', '0');
        axle.setAttribute('cy', '0');
        axle.setAttribute('r', (axleDiameter / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        group.appendChild(axle);
        if (viewCtx.viewSide === 'ds' && viewCtx.schematicView) {
            const firstHole = this.children[0];
            const startMarker = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
            startMarker.classList.add('flange-start-marker');
            const [x, y] = firstHole.xy(viewCtx);
            startMarker.setAttribute('cx', (x * 0.75).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
            startMarker.setAttribute('cy', (y * 0.75).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
            startMarker.setAttribute('r', '1.5');
            group.appendChild(startMarker);
        }
        this.children.forEach((child)=>{
            group.appendChild(child.render(viewCtx));
        });
        return group;
    }
}






class $9732f72c112e3eaa$export$e1620f021996d94c extends (0, $8e234942e6a87d00$export$7b5bf7981d51054e) {
    constructor(id, props){
        super(), this.id = id, this.props = props;
        this.nipple = this.generateNipple();
        this.holes = this.generateHoles();
    }
    get children() {
        return [
            this.nipple,
            ...this.holes
        ];
    }
    update(props) {
        this.props = {
            ...this.props,
            ...props
        };
        this.nipple = this.generateNipple(); // can be safely regenerated
        const newHoles = this.generateHoles();
        const n = Math.max(newHoles.length, this.holes.length);
        for(let i = 0; i < n; i++){
            const oldHole = this.holes[i];
            const newHole = newHoles[i];
            if (oldHole && newHole) oldHole.update(newHole.props);
            else if (!oldHole && newHole) this.holes[i] = newHole;
            else if (oldHole && !newHole) {
                this.holes = this.holes.slice(0, i);
                break;
            }
        }
    }
    generateNipple() {
        return new (0, $2dbce3f90165c269$export$b5329b670b24e23b)('NIPPLE', {
            angle: 0,
            distance: this.props.erd / 2,
            diameter: this.props.holeDiameter * 1.5,
            location: 'nipple',
            selectable: false
        });
    }
    generateHoles() {
        const holes = [];
        const angleStep = 360 / this.props.numHoles;
        const initAngle = angleStep / 2;
        for(let i = 0; i < this.props.numHoles; i++){
            const angle = initAngle + angleStep * i;
            let location = 'rim';
            let centerOffset = 0;
            if (i % 2 < 1 && this.props.drillingOffsetDs > 0) {
                location = this.props.flipOffsetOrder ? 'rim-nds' : 'rim-ds';
                centerOffset = this.props.drillingOffsetDs;
            } else if (i % 2 > 0 && this.props.drillingOffsetNds > 0) {
                location = this.props.flipOffsetOrder ? 'rim-ds' : 'rim-nds';
                centerOffset = this.props.drillingOffsetNds;
            }
            holes.push(new (0, $2dbce3f90165c269$export$b5329b670b24e23b)(`R${i + 1}`, {
                angle: angle,
                distance: this.props.erd / 2,
                diameter: this.props.holeDiameter,
                location: location,
                centerOffset: centerOffset
            }));
        }
        return holes;
    }
    render(viewCtx) {
        const s = viewCtx.scaler;
        const group = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'g');
        group.classList.add('rim');
        group.setAttribute('id', this.id);
        const outerRimDiameter = viewCtx.schematicView ? s.schematicRimOuterDiameter : s.pxPerMm * (this.props.erd + this.props.thickness / 2);
        const innerRimDiameter = viewCtx.schematicView ? s.schematicRimInnerDiameter : s.pxPerMm * (this.props.erd - this.props.thickness / 2);
        const outerCircle = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
        outerCircle.classList.add('select-resetting', 'rim-outer');
        outerCircle.setAttribute('cx', '0');
        outerCircle.setAttribute('cy', '0');
        outerCircle.setAttribute('r', (outerRimDiameter / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        const innerCircle = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
        innerCircle.classList.add('select-resetting', 'rim-inner');
        innerCircle.setAttribute('cx', '0');
        innerCircle.setAttribute('cy', '0');
        innerCircle.setAttribute('r', (innerRimDiameter / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        group.appendChild(outerCircle);
        group.appendChild(innerCircle);
        this.children.forEach((child)=>{
            group.appendChild(child.render(viewCtx));
        });
        return group;
    }
}





class $8f0743c5a17750ef$export$aa6dca09132ae0c3 extends (0, $8e234942e6a87d00$export$7b5bf7981d51054e) {
    constructor(id, props){
        super(), this.id = id, this.props = props, this.children = [];
    }
    update(props) {
        this.props = {
            ...this.props,
            ...props
        };
    }
    get length() {
        const fh = this.props.flangeHole;
        const rh = this.props.rimHole;
        const [xR, yR] = rh.xyMm;
        const [xF, yF] = fh.xyMm;
        const dx = xR - xF;
        const dy = yR - yF;
        const flatLength = Math.sqrt(dx * dx + dy * dy);
        const flangeHoleOffset = fh.centerOffset * (fh.isOnDs ? 1 : -1);
        const rimHoleOffset = rh.centerOffset * (rh.isOnDs ? 1 : -1);
        const latOffset = Math.abs(rimHoleOffset - flangeHoleOffset);
        const latAdjLength = Math.sqrt(latOffset * latOffset + flatLength * flatLength);
        const finalLength = latAdjLength - this.props.flangeHole.props.diameter / 2;
        return finalLength;
    }
    get angleAtRim() {
        const fh = this.props.flangeHole;
        const rh = this.props.rimHole;
        const [xR, yR] = rh.xyMm;
        const [xF, yF] = fh.xyMm;
        const dx = xR - xF;
        const dy = yR - yF;
        const flatLength = Math.sqrt(dx * dx + dy * dy);
        const flangeRadius = fh.props.distance;
        const angleDiff = Math.abs(rh.props.angle - fh.props.angle);
        const rimAngleRad = Math.asin(flangeRadius / flatLength * Math.sin(angleDiff * Math.PI / 180));
        return Math.abs(rimAngleRad * 180 / Math.PI);
    }
    get bracingAngle() {
        const fh = this.props.flangeHole;
        const rh = this.props.rimHole;
        const [xR, yR] = rh.xyMm;
        const [xF, yF] = fh.xyMm;
        const dx = xR - xF;
        const dy = yR - yF;
        const flatLength = Math.sqrt(dx * dx + dy * dy);
        const flangeHoleOffset = fh.centerOffset * (fh.isOnDs ? 1 : -1);
        const rimHoleOffset = rh.centerOffset * (rh.isOnDs ? 1 : -1);
        const latOffset = Math.abs(rimHoleOffset - flangeHoleOffset);
        return Math.atan(latOffset / flatLength) * 180 / Math.PI;
    }
    hasExtremeAngles(threshold) {
        return this.angleAtRim > threshold || this.bracingAngle > threshold;
    }
    render(viewCtx) {
        const spokeMarkerSizeRatio = 0.5;
        const group = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'g');
        group.classList.add('spoke');
        if ((0, $a8b110203455cd55$export$50fdfeece43146fd)().selectedId === this.id) group.classList.add('selected');
        if (this.props.flangeHole.isOnFarSide(viewCtx.viewSide)) group.classList.add('far-side');
        group.setAttribute('id', this.id);
        const innerGroup = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'g');
        const start = this.props.flangeHole;
        const end = this.props.rimHole;
        const line = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'line');
        line.setAttribute('x1', start.xy(viewCtx)[0].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        line.setAttribute('y1', start.xy(viewCtx)[1].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        line.setAttribute('x2', end.xy(viewCtx)[0].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        line.setAttribute('y2', end.xy(viewCtx)[1].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        const startMarker = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
        startMarker.classList.add('spoke-marker');
        startMarker.setAttribute('cx', start.xy(viewCtx)[0].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        startMarker.setAttribute('cy', start.xy(viewCtx)[1].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        startMarker.setAttribute('r', (start.d(viewCtx) * 0.5 * spokeMarkerSizeRatio).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        const endMarker = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
        endMarker.classList.add('spoke-marker');
        endMarker.setAttribute('cx', end.xy(viewCtx)[0].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        endMarker.setAttribute('cy', end.xy(viewCtx)[1].toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        endMarker.setAttribute('r', (end.d(viewCtx) * 0.5 * spokeMarkerSizeRatio).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
        if (this.hasExtremeAngles(viewCtx.angleThreshold)) endMarker.classList.add('warning');
        const title = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'title');
        let titleText = `Spoke ${this.id} | Length: ${this.length.toFixed(1)}mm`;
        if (this.group) titleText = titleText.concat(` | Group: ${this.group}`);
        title.textContent = titleText;
        const endMarkerTitle = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'title');
        let endMarkerTitleText = `Hole ${this.props.rimHole.id} | Rim angle: ${this.angleAtRim.toFixed(1)}\xb0 | Bracing angle: ${this.bracingAngle.toFixed(1)}\xb0`;
        endMarkerTitle.textContent = endMarkerTitleText;
        innerGroup.appendChild(line);
        innerGroup.appendChild(startMarker);
        innerGroup.appendChild(title);
        endMarker.appendChild(endMarkerTitle);
        if (this.group && viewCtx.schematicView) {
            const labelG = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'g');
            labelG.classList.add('spoke-group-label');
            const [sx, sy] = start.xy(viewCtx);
            const [ex, ey] = end.xy(viewCtx);
            const labelCircle = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'circle');
            labelCircle.classList.add('spoke-group-label-background');
            labelCircle.setAttribute('cx', ((sx + ex) / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
            labelCircle.setAttribute('cy', ((sy + ey) / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
            labelCircle.setAttribute('r', '5');
            const labelText = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'text');
            labelText.setAttribute('x', ((sx + ex) / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
            labelText.setAttribute('y', ((sy + ey) / 2).toFixed((0, $36c58dd8c5475691$export$d6d3992f3becc879)));
            labelText.setAttribute('text-anchor', 'middle');
            labelText.textContent = this.group;
            labelG.appendChild(labelCircle);
            labelG.appendChild(labelText);
            innerGroup.appendChild(labelG);
        }
        group.appendChild(innerGroup);
        group.appendChild(endMarker);
        this.addEventHandlers(group);
        return group;
    }
    addEventHandlers(elem) {
        elem.addEventListener('click', ()=>{
            const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
            state.select(state.selectedId === this.id ? undefined : this.id);
        });
        elem.addEventListener('dblclick', ()=>{
            const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
            if (state.selectedId === this.id) {
                state.wheel?.removeSpoke(this.id);
                state.select(undefined);
            }
        });
    }
}



const $3d7ca20c60252352$export$7978a6ddf29f4374 = (val, n)=>{
    const lower = Math.floor(val / n) * n;
    const upper = lower + n;
    return Math.abs(val - lower) < Math.abs(val - upper) ? lower : upper;
};


class $5582a769781ae206$export$ae16e1bcb40d6793 extends (0, $8e234942e6a87d00$export$7b5bf7981d51054e) {
    constructor(id, props){
        super(), this.id = id, this.props = props, this.spokes = [];
        this.rim = this.generateRim();
        const [dsFlange, ndsFlange] = this.generateFlanges();
        this.dsFlange = dsFlange;
        this.ndsFlange = ndsFlange;
    }
    get children() {
        return [
            this.rim,
            this.dsFlange,
            this.ndsFlange,
            ...this.spokes
        ];
    }
    update(props) {
        this.props = {
            ...this.props,
            ...props
        };
        this.rim.update({
            erd: this.props.rimErd,
            numHoles: this.props.rimNumHoles,
            holeDiameter: this.props.spokeHoleDiameter,
            drillingOffsetDs: this.props.rimDrillingOffsetDs,
            drillingOffsetNds: this.props.rimDrillingOffsetNds,
            flipOffsetOrder: this.props.rimFlipOffsetOrder
        });
        this.dsFlange.update({
            pcd: this.props.dsFlangePcd,
            numHoles: this.props.dsFlangeNumHoles,
            rotation: this.props.hubRotation,
            spokeHoleDiameter: this.props.spokeHoleDiameter,
            centerOffset: this.props.dsFlangeOffset
        });
        this.ndsFlange.update({
            pcd: this.props.ndsFlangePcd,
            numHoles: this.props.ndsFlangeNumHoles,
            rotation: this.props.hubRotation - this.props.dsNdsOffset,
            spokeHoleDiameter: this.props.spokeHoleDiameter,
            centerOffset: this.props.ndsFlangeOffset
        });
        this.cleanupSpokes();
        this.groupSpokes();
    }
    get size() {
        return this.props.rimErd + 30;
    }
    generateRim() {
        return new (0, $9732f72c112e3eaa$export$e1620f021996d94c)('RIM', {
            erd: this.props.rimErd,
            thickness: 15,
            numHoles: this.props.rimNumHoles,
            holeDiameter: this.props.spokeHoleDiameter,
            drillingOffsetDs: this.props.rimDrillingOffsetDs,
            drillingOffsetNds: this.props.rimDrillingOffsetNds,
            flipOffsetOrder: this.props.rimFlipOffsetOrder
        });
    }
    generateFlanges() {
        const dsFlange = new (0, $2f44413d4ef6c8fa$export$8adfa152bd3633af)('FLANGE_DS', {
            pcd: this.props.dsFlangePcd,
            numHoles: this.props.dsFlangeNumHoles,
            side: 'ds',
            rotation: this.props.hubRotation,
            spokeHoleDiameter: this.props.spokeHoleDiameter,
            centerOffset: this.props.dsFlangeOffset
        });
        const ndsFlange = new (0, $2f44413d4ef6c8fa$export$8adfa152bd3633af)('FLANGE_NDS', {
            pcd: this.props.ndsFlangePcd,
            numHoles: this.props.ndsFlangeNumHoles,
            side: 'nds',
            rotation: this.props.hubRotation - this.props.dsNdsOffset,
            spokeHoleDiameter: this.props.spokeHoleDiameter,
            centerOffset: this.props.ndsFlangeOffset
        });
        return [
            dsFlange,
            ndsFlange
        ];
    }
    reorderChildren(viewCtx) {
        const dsSpokes = this.spokes.filter((spoke)=>spoke.props.flangeHole.location === 'flange-ds');
        const ndsSpokes = this.spokes.filter((spoke)=>spoke.props.flangeHole.location === 'flange-nds');
        if (viewCtx.viewSide === 'ds') return [
            this.rim,
            this.ndsFlange,
            ...ndsSpokes,
            this.dsFlange,
            ...dsSpokes
        ];
        else return [
            this.rim,
            this.dsFlange,
            ...dsSpokes,
            this.ndsFlange,
            ...ndsSpokes
        ];
    }
    addSpoke(holeOne, holeTwo) {
        if (holeOne.isOnFlange && holeTwo.isOnRim) {
            const flangeHole = holeOne;
            const rimHole = holeTwo;
            const spoke = new (0, $8f0743c5a17750ef$export$aa6dca09132ae0c3)(`${flangeHole.id}${rimHole.id}`, {
                flangeHole: flangeHole,
                rimHole: rimHole
            });
            this.spokes.push(spoke);
            (0, $a8b110203455cd55$export$50fdfeece43146fd)().select(spoke.id);
            this.groupSpokes();
            return true;
        } else if (holeOne.isOnRim && holeTwo.isOnFlange) {
            const flangeHole = holeTwo;
            const rimHole = holeOne;
            const spoke = new (0, $8f0743c5a17750ef$export$aa6dca09132ae0c3)(`${flangeHole.id}${rimHole.id}`, {
                flangeHole: flangeHole,
                rimHole: rimHole
            });
            this.spokes.push(spoke);
            (0, $a8b110203455cd55$export$50fdfeece43146fd)().select(spoke.id);
            this.groupSpokes();
            return true;
        }
        return false;
    }
    removeSpoke(id) {
        this.spokes = this.spokes.filter((spoke)=>spoke.id !== id);
        this.groupSpokes();
    }
    removeAllSpokes() {
        this.spokes = [];
    }
    cleanupSpokes() {
        // Remove orphaned spokes
        this.spokes = this.spokes.filter((spoke)=>{
            return this.find(spoke.props.rimHole.id) && this.find(spoke.props.flangeHole.id);
        });
    }
    groupSpokes() {
        const roundPrecision = this.props.spokeGroupingPrecision;
        const spokeLengths = Array.from(new Set(this.spokes.map((spoke)=>(0, $3d7ca20c60252352$export$7978a6ddf29f4374)(spoke.length, roundPrecision))));
        spokeLengths.sort();
        for(let i = 0; i < this.spokes.length; i++){
            const l = (0, $3d7ca20c60252352$export$7978a6ddf29f4374)(this.spokes[i].length, roundPrecision);
            const group = String.fromCharCode(65 + spokeLengths.indexOf(l));
            this.spokes[i].group = group;
        }
    }
    getSpokeGroups() {
        const groups = {};
        for (const spoke of this.spokes){
            if (!spoke.group) continue;
            if (spoke.group in groups) groups[spoke.group][1] += 1;
            else groups[spoke.group] = [
                (0, $3d7ca20c60252352$export$7978a6ddf29f4374)(spoke.length, this.props.spokeGroupingPrecision),
                1
            ];
        }
        return Object.entries(groups).sort((a, b)=>a[0].localeCompare(b[0])).map(([group, v])=>[
                group,
                ...v
            ]);
    }
    get spokeDefs() {
        return this.spokes.map((spoke)=>`${spoke.props.rimHole.id}${spoke.props.flangeHole.id}`).join('');
    }
    generateSpokesFromDefs(definitions) {
        const rgx = /(?<rim>R\d+)(?<flange>(N|S)\d+)/gm;
        const matches = Array.from(definitions.matchAll(rgx));
        const takenHoleIds = [];
        this.removeAllSpokes();
        for (const match of matches){
            const rimHoleId = match.groups?.rim;
            const flangeHoleId = match.groups?.flange;
            if (!rimHoleId || !flangeHoleId) continue;
            if (rimHoleId in takenHoleIds || flangeHoleId in takenHoleIds) continue;
            const rimHole = this.find(rimHoleId);
            const flangeHole = this.find(flangeHoleId);
            if (!rimHole || !flangeHole) continue;
            this.addSpoke(rimHole, flangeHole);
        }
        (0, $a8b110203455cd55$export$50fdfeece43146fd)().select(undefined);
    }
    hasExtremeAngles(threshold) {
        return this.spokes.some((spoke)=>spoke.hasExtremeAngles(threshold));
    }
    render(viewCtx) {
        const group = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'g');
        group.classList.add('wheel');
        const reorderedChildren = this.reorderChildren(viewCtx);
        reorderedChildren.forEach((child)=>{
            group.appendChild(child.render(viewCtx));
        });
        return group;
    }
}


class $91fc99e7e897d8a5$export$3e839cb79af5c635 {
    constructor(width, height, wheelSize){
        this.width = width;
        this.height = height;
        this.wheelSize = wheelSize;
        this.margin = 10;
    }
    get minSide() {
        return Math.min(this.width, this.height);
    }
    get pxPerMm() {
        return (this.minSide - 2 * this.margin) / this.wheelSize;
    }
    get schematicRimOuterDiameter() {
        return this.minSide - this.margin * 2;
    }
    get schematicRimInnerDiameter() {
        return this.schematicRimOuterDiameter * 0.92;
    }
    get schematicNearFlangeDiameter() {
        return this.schematicRimOuterDiameter * 0.25;
    }
    get schematicFarFlangeDiameter() {
        return this.schematicRimOuterDiameter * 0.3;
    }
    get schematicAxleDiameter() {
        return this.schematicRimOuterDiameter * 0.04;
    }
    get schematicNearFlangeHoleDiameter() {
        return this.schematicRimOuterDiameter * 0.02;
    }
    get schematicFarFlangeHoleDiameter() {
        return this.schematicNearFlangeHoleDiameter * 0.8;
    }
    get schematicRimHoleDiameter() {
        return this.schematicNearFlangeHoleDiameter;
    }
    get schematicNearRimHoleDiameter() {
        return this.schematicRimHoleDiameter * 1.2;
    }
    get schematicFarRimHoleDiameter() {
        return this.schematicRimHoleDiameter * 0.8;
    }
    get schematicNippleHoleDiameter() {
        return this.schematicRimHoleDiameter * 1.5;
    }
}





const $b4044cc2d87dcf53$export$7afd9c1079ecedf7 = {
    'radial-28h': 'rimNumHoles=28&dsFlangeNumHoles=14&ndsFlangeNumHoles=14&hubRotation=0.25&dsNdsOffset=0.50&spokes=R1S1R2N2R3S2R4N3R5S3R6N4R7S4R8N5R9S5R10N6R11S6R12N7R13S7R14N8R15S8R16N9R17S9R18N10R19S10R20N11R21S11R22N12R23S12R24N13R25S13R26N14R27S14R28N1',
    'radial-32h': 'rimNumHoles=32&dsFlangeNumHoles=16&ndsFlangeNumHoles=16&hubRotation=0.25&dsNdsOffset=0.50&spokes=R1S1R2N2R3S2R4N3R5S3R6N4R7S4R8N5R9S5R10N6R11S6R12N7R13S7R14N8R15S8R16N9R17S9R18N10R19S10R20N11R21S11R22N12R23S12R24N13R25S13R26N14R27S14R28N15R29S15R30N16R31S16R32N1',
    'radial-36h': 'rimNumHoles=36&dsFlangeNumHoles=18&ndsFlangeNumHoles=18&hubRotation=0.25&dsNdsOffset=0.50&spokes=R1S1R2N2R3S2R4N3R5S3R6N4R7S4R8N5R9S5R10N6R11S6R12N7R13S7R14N8R15S8R16N9R17S9R18N10R19S10R20N11R21S11R22N12R23S12R24N13R25S13R26N14R27S14R28N15R29S15R30N16R31S16R32N17R33S17R34N18R35S18R36N1',
    '1cross-28h': 'rimNumHoles=28&dsFlangeNumHoles=14&ndsFlangeNumHoles=14&hubRotation=1.75&dsNdsOffset=0.50&spokes=R2S1R4S14R1N1R3N14R8S2R6S3R7N2R5N3R12S4R10S5R11N4R9N5R16S6R14S7R15N6R13N7R20S8R18S9R17N9R19N8R24S10R22S11R23N10R21N11R28S12R26S13R25N13R27N12',
    '1cross-32h': 'rimNumHoles=32&dsFlangeNumHoles=16&ndsFlangeNumHoles=16&hubRotation=1.75&dsNdsOffset=0.50&spokes=R2S1R1N1R8S2R6S3R7N2R5N3R12S4R10S5R11N4R9N5R16S6R14S7R15N6R13N7R20S8R18S9R17N9R19N8R24S10R22S11R23N10R21N11R28S12R26S13R25N13R27N12R4S16R3N16R32S14R30S15R29N15R31N14',
    '1cross-36h': 'rimNumHoles=36&dsFlangeNumHoles=18&ndsFlangeNumHoles=18&hubRotation=1.75&dsNdsOffset=0.50&spokes=R2S1R1N1R8S2R6S3R7N2R5N3R12S4R10S5R11N4R9N5R16S6R14S7R15N6R13N7R20S8R18S9R17N9R19N8R24S10R22S11R23N10R21N11R28S12R26S13R25N13R27N12R32S14R30S15R29N15R31N14R3N18R4S18R34S17R36S16R33N17R35N16',
    '2cross-28h': 'rimNumHoles=28&dsFlangeNumHoles=14&ndsFlangeNumHoles=14&hubRotation=1.75&dsNdsOffset=0.50&spokes=R2S2R4S13R1N2R3N13R8S1R6S4R12S3R10S6R16S5R14S8R20S7R18S10R24S9R22S12R28S11R26S14R7N1R5N4R11N3R9N6R15N5R13N8R19N7R17N10R23N9R21N12R27N11R25N14',
    '2cross-32h': 'rimNumHoles=32&dsFlangeNumHoles=16&ndsFlangeNumHoles=16&hubRotation=1.75&dsNdsOffset=0.50&spokes=R2S2R1N2R8S1R6S4R12S3R10S6R16S5R14S8R20S7R18S10R24S9R22S12R28S11R26S14R7N1R5N4R11N3R9N6R15N5R13N8R19N7R17N10R23N9R21N12R27N11R25N14R30S16R32S13R4S15R31N13R3N15R29N16',
    '2cross-36h': 'rimNumHoles=36&dsFlangeNumHoles=18&ndsFlangeNumHoles=18&hubRotation=1.75&dsNdsOffset=0.50&spokes=R2S2R1N2R8S1R6S4R12S3R10S6R16S5R14S8R20S7R18S10R24S9R22S12R28S11R26S14R7N1R5N4R11N3R9N6R15N5R13N8R19N7R17N10R23N9R21N12R27N11R25N14R30S16R32S13R31N13R29N16R36S15R4S17R34S18R33N18R3N17R35N15',
    '3cross-28h': 'rimNumHoles=28&dsFlangeNumHoles=14&ndsFlangeNumHoles=14&hubRotation=1.75&dsNdsOffset=0.50&spokes=R28S10R22S13R4S12R26S1R8S14R2S3R12S2R6S5R16S4R20S6R24S8R10S7R14S9R18S11R1N3R11N2R15N4R19N6R23N8R27N10R3N12R7N14R25N1R21N13R17N11R13N9R9N7R5N5',
    '3cross-32h': 'rimNumHoles=32&dsFlangeNumHoles=16&ndsFlangeNumHoles=16&hubRotation=1.75&dsNdsOffset=0.50&spokes=R28S10R22S13R2S3R12S2R6S5R16S4R20S6R24S8R10S7R14S9R18S11R1N3R11N2R15N4R19N6R23N8R27N10R21N13R17N11R13N9R9N7R5N5R32S12R4S14R8S16R30S1R26S15R29N1R25N15R31N12R3N14R7N16',
    '3cross-36h': 'rimNumHoles=36&dsFlangeNumHoles=18&ndsFlangeNumHoles=18&hubRotation=1.75&dsNdsOffset=0.50&spokes=R28S10R22S13R2S3R12S2R6S5R16S4R20S6R24S8R10S7R14S9R18S11R1N3R11N2R15N4R19N6R23N8R27N10R21N13R17N11R13N9R9N7R5N5R32S12R26S15R25N15R31N12R36S14R4S16R8S18R34S1R30S17R33N1R29N17R35N14R3N16R7N18'
};


const $05531dc17be84a3f$var$toggleRealisticScaleElements = (realisticScaleValue)=>{
    document.querySelectorAll('.realistic-only').forEach((el)=>{
        el.classList.toggle('hidden', !realisticScaleValue);
    });
};
const $05531dc17be84a3f$export$42ab1c11993f6cbb = ()=>{
    const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
    const wheelParams = state.wheelParameters;
    for(const paramName in wheelParams){
        const param = wheelParams[paramName];
        const input = document.querySelector(`input[name=${paramName}]`);
        if (!input && paramName !== 'spokes') {
            console.warn(`Input with name '${paramName}' not found!}'`);
            continue;
        }
        if (param instanceof (0, $9ff2d73067b60eff$export$7955351c9f2e4bbf)) input.value = param.format();
        else if (param instanceof (0, $9ff2d73067b60eff$export$a770ed677459fd90)) input.checked = param.value;
    }
    const viewParams = state.viewParameters;
    for(const paramName in viewParams){
        const param = viewParams[paramName];
        const input = document.querySelector(`input[name=${paramName}]`);
        if (param instanceof (0, $9ff2d73067b60eff$export$7955351c9f2e4bbf)) input.value = param.format();
        else if (param instanceof (0, $9ff2d73067b60eff$export$a770ed677459fd90)) {
            input.checked = param.value;
            if (paramName === 'realisticScale') $05531dc17be84a3f$var$toggleRealisticScaleElements(param.value);
        }
    }
};
const $05531dc17be84a3f$export$1bce55c118e548cf = (name)=>{
    const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
    let input = document.querySelector(`input[name="${name}"]`);
    if (!input) {
        console.warn(`Input with name '${name}' not found!}'`);
        return;
    }
    // @ts-ignore
    const param = state.wheelParameters[name] ?? state.viewParameters[name];
    if (!param) {
        name !== 'spokes' && console.warn(`Parameter with name '${name}' not found!}'`);
        return;
    }
    if (input.type === 'number') param.parse(input.value);
    else if (input.type === 'checkbox') param.parse(input.checked);
    if (name === 'realisticScale') $05531dc17be84a3f$var$toggleRealisticScaleElements(param.value);
};
const $05531dc17be84a3f$export$5963f65888cfb9ea = ()=>{
    document.querySelectorAll('input').forEach((input)=>{
        if (Object.keys((0, $9ff2d73067b60eff$export$7c24c21e0aad25cf)).includes(input.name)) input.addEventListener('change', ()=>{
            $05531dc17be84a3f$export$1bce55c118e548cf(input.name);
            (0, $a8b110203455cd55$export$50fdfeece43146fd)().refresh(true);
        });
        else if (Object.keys((0, $9ff2d73067b60eff$export$72cb2a5beca2f59c)).includes(input.name)) input.addEventListener('change', ()=>{
            $05531dc17be84a3f$export$1bce55c118e548cf(input.name);
            (0, $a8b110203455cd55$export$50fdfeece43146fd)().refresh();
        });
    });
};
const $05531dc17be84a3f$export$fed11826829cc201 = ()=>{
    document.getElementById('clear-spokes-btn')?.addEventListener('click', ()=>{
        const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
        state.wheel?.removeAllSpokes();
        state.refresh();
    });
};
const $05531dc17be84a3f$export$42afdc1cf8402792 = ()=>{
    document.addEventListener('keyup', (event)=>{
        const editingInputs = document.activeElement?.tagName.toLowerCase() === 'input';
        if (editingInputs) return;
        if (event.key === 'd' || event.key === 'D' || event.key === 'Backspace') {
            const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
            if (!state.selectedId) return;
            const selectedPart = state.wheel?.find(state.selectedId);
            if (!selectedPart) return;
            if (selectedPart instanceof (0, $8f0743c5a17750ef$export$aa6dca09132ae0c3)) {
                state.wheel?.removeSpoke(state.selectedId);
                state.refresh();
            }
        }
    });
};
const $05531dc17be84a3f$export$486e3b04754b080b = ()=>{
    document.querySelectorAll('.select-resetting').forEach((el)=>{
        el.addEventListener('click', ()=>{
            (0, $a8b110203455cd55$export$50fdfeece43146fd)().select(undefined);
        });
    });
};
const $05531dc17be84a3f$export$e28fd4e4ffd5cc7e = ()=>{
    document.getElementById('copy-url-btn')?.addEventListener('click', ()=>{
        const url = $05531dc17be84a3f$export$9be1252cefe4c1b4();
        navigator.clipboard.writeText(url);
        const btn = document.getElementById('copy-url-btn');
        if (btn) {
            const txtBackup = btn.textContent;
            btn.textContent = 'Copied!';
            setTimeout(()=>{
                btn.textContent = txtBackup;
            }, 1500);
        }
    });
};
const $05531dc17be84a3f$export$1f19c9ddf3969df = (searchParameters)=>{
    const searchParams = searchParameters ?? new URLSearchParams(window.location.search);
    const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
    const paramPairs = Array.from(searchParams.entries());
    if (paramPairs.length > 0) window.umami?.track('UrlWithParams', {
        numParams: paramPairs.length
    });
    for (const [name, value] of paramPairs){
        // @ts-ignore
        const param = state.wheelParameters[name] ?? state.viewParameters[name];
        if (!param) {
            name !== 'spokes' && console.warn(`Parameter with name '${name}' not found!'`);
            continue;
        }
        param.parse(value);
        searchParams.delete(name);
    }
    const spokeDefs = searchParams.get('spokes');
    // Clean query parameters
    const url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach((key)=>{
        url.searchParams.delete(key);
    });
    window.history.replaceState({}, '', url);
    return spokeDefs;
};
const $05531dc17be84a3f$export$9be1252cefe4c1b4 = ()=>{
    const url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach((key)=>{
        url.searchParams.delete(key);
    });
    const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
    const allParams = {
        ...state.wheelParameters,
        ...state.viewParameters
    };
    for (const [paramName, param] of Object.entries(allParams))if (param.value !== param.defaultValue) url.searchParams.set(paramName, param.format());
    if (state.wheel?.spokeDefs) url.searchParams.set('spokes', state.wheel.spokeDefs);
    return url.toString();
};
const $05531dc17be84a3f$export$1c968a720bc8f2d3 = ()=>{
    document.querySelector('select[name=preset-select]')?.addEventListener('change', (event)=>{
        const select = event.target;
        const presetName = select.value;
        if (presetName === 'none') return;
        const presetUrl = (0, $b4044cc2d87dcf53$export$7afd9c1079ecedf7)[presetName];
        if (!presetUrl) return;
        const spokeDefs = $05531dc17be84a3f$export$1f19c9ddf3969df(new URLSearchParams(presetUrl));
        $05531dc17be84a3f$export$42ab1c11993f6cbb();
        (0, $a8b110203455cd55$export$50fdfeece43146fd)().refresh(true);
        !!spokeDefs && (0, $a8b110203455cd55$export$50fdfeece43146fd)().wheel?.generateSpokesFromDefs(spokeDefs);
        (0, $a8b110203455cd55$export$50fdfeece43146fd)().refresh(true);
        select.value = 'none';
    });
};
const $05531dc17be84a3f$export$f215871896703a07 = ()=>{
    document.getElementById('help-btn')?.addEventListener('click', (event)=>{
        event.preventDefault();
        document.querySelector('.help-modal')?.classList.toggle('hidden');
    });
    document.getElementById('help-close-btn')?.addEventListener('click', (event)=>{
        event.preventDefault();
        console.log('closing...');
        document.querySelector('.help-modal')?.classList.toggle('hidden');
    });
};
const $05531dc17be84a3f$export$207040c008d468df = ()=>{
    let animationStart = -1;
    let prevAngle = 0;
    let origTransform = '';
    let originalBtnText = '';
    let animationId = undefined;
    const stopSpin = ()=>{
        const spinBtn = document.getElementById('spin-btn');
        if (animationId) cancelAnimationFrame(animationId);
        animationStart = -1;
        prevAngle = 0;
        if (origTransform) document.querySelector('.wheel')?.setAttribute('transform', origTransform);
        if (spinBtn) spinBtn.textContent = originalBtnText;
        originalBtnText = '';
        animationId = undefined;
        document.querySelector('input[name="realisticScale"]')?.removeAttribute('disabled');
    };
    const animateSpin = (timestamp)=>{
        const svgContainer = document.querySelector('svg.svg-container');
        const wheelElem = document.querySelector('.wheel');
        const spinBtn = document.getElementById('spin-btn');
        if (!svgContainer || !wheelElem) return;
        const w = Number.parseFloat(svgContainer.getAttribute('width') || '0');
        const h = Number.parseFloat(svgContainer.getAttribute('height') || '0');
        if (animationStart < 0) {
            originalBtnText = spinBtn.textContent;
            spinBtn.textContent = 'Stop';
            animationStart = timestamp;
            origTransform = wheelElem.getAttribute('transform') || '';
            document.querySelector('input[name="realisticScale"]')?.setAttribute('disabled', 'true');
        }
        const elapsedSec = (timestamp - animationStart) / 1000;
        const dirMult = (0, $a8b110203455cd55$export$50fdfeece43146fd)().viewParameters.ndsView.value ? -1 : 1;
        const angleSpeed = Math.min(3 / elapsedSec, 3600) * dirMult;
        const angle = (prevAngle + angleSpeed) % 360;
        prevAngle = angle;
        const transform = `${origTransform} rotate(${angle} ${w / 2} ${h / 2})`;
        wheelElem.setAttribute('transform', transform);
        if (Math.abs(angleSpeed) > 0.35 || Math.abs(angle) > 5) animationId = requestAnimationFrame(animateSpin);
        else stopSpin();
    };
    document.getElementById('spin-btn')?.addEventListener('click', ()=>{
        const spinBtn = document.getElementById('spin-btn');
        if (spinBtn.textContent === 'Stop') stopSpin();
        else {
            const wheelElem = document.querySelector('.wheel');
            if (!wheelElem) return;
            animationId = requestAnimationFrame(animateSpin);
        }
    });
};
const $05531dc17be84a3f$export$2f28a6ee45295327 = ()=>{
    window.addEventListener('beforeprint', ()=>{
        if (window.umami?.track) window.umami.track('PrintPreviewOpened');
    });
};




const $904ba11274ab7f39$export$c756601c42ccbced = (groups)=>{
    const container = document.getElementById('spoke-summary');
    container?.replaceChildren();
    if (groups.length === 0) {
        const msg = document.createElement('p');
        msg.classList.add('summary-message');
        msg.textContent = 'Wheel has no spokes';
        container?.appendChild(msg);
    } else {
        const angleThreshold = (0, $a8b110203455cd55$export$50fdfeece43146fd)().viewParameters.angleThreshold.value;
        const hasExtremeAngles = (0, $a8b110203455cd55$export$50fdfeece43146fd)().wheel?.hasExtremeAngles(angleThreshold) ?? false;
        if (hasExtremeAngles) {
            const msg = document.createElement('p');
            msg.classList.add('summary-message', 'warning');
            msg.textContent = `Some spokes have rim or bracing angle exeeding ${angleThreshold.toFixed(1)} degrees!`;
            container?.appendChild(msg);
        }
        const table = document.createElement('table');
        table.classList.add('spoke-summary-table');
        let html = '<thead><tr><th>Group</th><th>Length, mm</th><th>Quantity</th></tr></thead>';
        let numRows = 0;
        const numSpokes = groups.reduce((acc, cur)=>acc + cur[2], 0);
        for (const [group, length, quantity] of groups){
            const row = `<tr><td>${group}</td><td>${length.toFixed(1)}</td><td>${quantity}</td></tr>`;
            html += row;
            numRows += 1;
        }
        if (numRows > 1) html += `<tr><td><i>Total<i></td><td></td><td><i>${numSpokes}<i></td></tr>`;
        table.innerHTML = html;
        container?.appendChild(table);
        const urlMsg = document.createElement('p');
        urlMsg.classList.add('summary-build-url', 'print-only');
        urlMsg.textContent = `Build url: ${(0, $05531dc17be84a3f$export$9be1252cefe4c1b4)()}`;
        container?.appendChild(urlMsg);
    }
};


const $a76b9b34b3e06f29$var$getCleanCanvas = ()=>{
    const svg = document.querySelector('svg.svg-container');
    if (!svg) throw new Error('No SVG element found');
    svg.innerHTML = '';
    const background = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'rect');
    background.setAttribute('x', '0');
    background.setAttribute('y', '0');
    background.setAttribute('width', '100%');
    background.setAttribute('height', '100%');
    background.classList.add('background', 'select-resetting');
    svg.appendChild(background);
    return svg;
};
const $a76b9b34b3e06f29$var$createMessage = (message)=>{
    const text = document.createElementNS((0, $8e234942e6a87d00$export$276d1de0bc02ff5b), 'text');
    text.classList.add('message');
    text.setAttribute('x', '5px');
    text.setAttribute('y', '20px');
    text.textContent = message;
    return text;
};
const $a76b9b34b3e06f29$var$drawMessage = (message)=>{
    const svg = $a76b9b34b3e06f29$var$getCleanCanvas();
    const text = $a76b9b34b3e06f29$var$createMessage(message);
    svg.appendChild(text);
};
const $a76b9b34b3e06f29$var$drawWheel = (width, height)=>{
    const svg = $a76b9b34b3e06f29$var$getCleanCanvas();
    const wheel = (0, $a8b110203455cd55$export$50fdfeece43146fd)().wheel;
    if (!wheel) return;
    const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
    const scaler = new (0, $91fc99e7e897d8a5$export$3e839cb79af5c635)(width, height, wheel.size);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    const wheelElem = wheel.render({
        scaler: scaler,
        viewSide: state.viewParameters.ndsView.value ? 'nds' : 'ds',
        schematicView: !state.viewParameters.realisticScale.value,
        angleThreshold: state.viewParameters.angleThreshold.value
    });
    wheelElem.setAttribute('transform', `translate(${width / 2} ${height / 2})`);
    svg.appendChild(wheelElem);
    const dirLabel = state.viewParameters.ndsView.value ? '[BIKE FRONT]' : '[BIKE BACK]';
    svg.appendChild($a76b9b34b3e06f29$var$createMessage(dirLabel));
    return wheel;
};
const $a76b9b34b3e06f29$var$getWheelProps = ()=>{
    const params = (0, $a8b110203455cd55$export$50fdfeece43146fd)().wheelParameters;
    return {
        rimErd: params.rimErd.value,
        rimNumHoles: params.rimNumHoles.value,
        rimDrillingOffsetDs: params.rimDrillingOffsetDs.value,
        rimDrillingOffsetNds: params.rimDrillingOffsetNds.value,
        rimFlipOffsetOrder: params.rimFlipOffsetOrder.value,
        dsFlangePcd: params.dsFlangePcd.value,
        ndsFlangePcd: params.ndsFlangePcd.value,
        dsFlangeOffset: params.dsFlangeOffset.value,
        ndsFlangeOffset: params.ndsFlangeOffset.value,
        dsFlangeNumHoles: params.dsFlangeNumHoles.value,
        ndsFlangeNumHoles: params.ndsFlangeNumHoles.value,
        hubRotation: params.hubRotation.value,
        dsNdsOffset: params.dsNdsOffset.value,
        spokeHoleDiameter: params.spokeHoleDiameter.value,
        spokeGroupingPrecision: params.spokeGroupingPrecision.value
    };
};
const $a76b9b34b3e06f29$var$buildWheel = (spokeDefs)=>{
    const wheel = new (0, $5582a769781ae206$export$ae16e1bcb40d6793)('WHEEL', $a76b9b34b3e06f29$var$getWheelProps());
    if (spokeDefs) wheel.generateSpokesFromDefs(spokeDefs);
    (0, $a8b110203455cd55$export$50fdfeece43146fd)().wheel = wheel;
};
const $a76b9b34b3e06f29$var$refresh = (recalculate)=>{
    const svgBox = document.querySelector('svg.svg-container')?.getBoundingClientRect();
    if (!svgBox) return;
    if (Math.min(svgBox.width, svgBox.height) < 400) {
        $a76b9b34b3e06f29$var$drawMessage('Window too small!');
        return;
    }
    if (!!recalculate) {
        const state = (0, $a8b110203455cd55$export$50fdfeece43146fd)();
        state.wheel?.update($a76b9b34b3e06f29$var$getWheelProps());
        if (state.selectedId && state.wheel?.find(state.selectedId) === undefined) state.select(undefined);
    }
    const wheel = $a76b9b34b3e06f29$var$drawWheel(svgBox.width, svgBox.height);
    (0, $05531dc17be84a3f$export$486e3b04754b080b)();
    if (wheel) (0, $904ba11274ab7f39$export$c756601c42ccbced)(wheel.getSpokeGroups());
};
window.addEventListener('resize', ()=>{
    $a76b9b34b3e06f29$var$refresh();
});
window.addEventListener('load', ()=>{
    const spokeDefs = (0, $05531dc17be84a3f$export$1f19c9ddf3969df)();
    (0, $05531dc17be84a3f$export$42ab1c11993f6cbb)();
    (0, $05531dc17be84a3f$export$5963f65888cfb9ea)();
    (0, $05531dc17be84a3f$export$fed11826829cc201)();
    (0, $05531dc17be84a3f$export$42afdc1cf8402792)();
    (0, $05531dc17be84a3f$export$e28fd4e4ffd5cc7e)();
    (0, $05531dc17be84a3f$export$1c968a720bc8f2d3)();
    (0, $05531dc17be84a3f$export$f215871896703a07)();
    (0, $05531dc17be84a3f$export$207040c008d468df)();
    (0, $05531dc17be84a3f$export$2f28a6ee45295327)();
    $a76b9b34b3e06f29$var$buildWheel(spokeDefs);
    (0, $a8b110203455cd55$export$50fdfeece43146fd)().refresh = $a76b9b34b3e06f29$var$refresh;
    $a76b9b34b3e06f29$var$refresh();
});


//# sourceMappingURL=spokecalc.e2dc66b0.js.map
